import React from "react";
import { DgaIcon, DgaButton, DgaTag } from "platformscode-new-react";
import { checkPageDirection } from "../../hooks/checkPageDirection";

const Card = ({
  style,
  icon,
  title,
  description,
  image,
  imageWidth,
  imageHeight,
  external,
  showPrimaryAction = false,
  primaryActionLabel = "نص",
  primaryTrailIconType = "location-01",
  linkPrimaryAction,
  showPrimaryIcon = false,
  overridePrimaryAction,
  disablePrimaryAction = false,

  logoImage = false,   // <-- comes from props

  showSecondaryAction = false,
  secondaryActionLabel,
  linkSecondaryAction,
  buttonColor = "primary-brand",
  tagLable,
  children
}) => {


  // RTL detection
  const isRTL = checkPageDirection();

  const resolvedTrailIconType =
    primaryTrailIconType === "arrow"
      ? isRTL
        ? "arrow-left-02"
        : "arrow-right-02"
      : primaryTrailIconType;

  return (
    <div className="card" style={style}>

      {/* image */}

      {image && (
        <div>
          <img
            className={`${logoImage ? "" : "card-img"}`}
            src={image}
            width={imageWidth || 400}
            height={imageHeight || 200}
            alt={title}
            loading="lazy"
            decoding="async"
            sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
            style={{ objectFit: "cover" }}
          />
        </div>
      )}
      {/* optional icon */}
      {icon && (
        <div className="circular-green">
          <DgaIcon
            color="#067647"
            icon={icon}
            size={24}
            type="rounded"
            variant="stroke"
          />
        </div>
      )}

      {/* content */}
      <div className="card-content">
        <div className="title">{title}</div>
        {description && <div className="disc">{description}</div>}
        {children}
      </div>

      {/* tag */}
      {tagLable && (
        <DgaTag label={tagLable} size="md" variant="neutral" />
      )}

      {/* actions */}
      <div
        className={`flex btn-card ${secondaryActionLabel ? "gap-[12px]" : "gap-0"
          }`}
      >
        {/* secondary button */}
        {showSecondaryAction && (
          <DgaButton
            tabIndex="0"
            trailIcon
            trailIconProps={{ size: 16, type: "standard", variant: "stroke" }}
            label={secondaryActionLabel}
            size="md"
            variant="secondary-outline"
            onClick={linkSecondaryAction}
          />
        )}

        {/* primary button */}
        {showPrimaryAction && (
          <>
            {buttonColor !== "primary-brand" ? (
              <div tabIndex="0"
                className={`${buttonColor} flex justify-between gap-[4px]`}
                onClick={() => {
                  if (overridePrimaryAction) return overridePrimaryAction();

                  if (external) {
                    window.open(linkPrimaryAction, "_blank", "noopener,noreferrer");
                  } else {
                    window.location.href = linkPrimaryAction;
                  }
                }}
              >
                {primaryActionLabel}
                <DgaIcon
                  color=""
                  icon={resolvedTrailIconType}
                  size={16}
                  type="standard"
                  variant="stroke"
                />
              </div>
            ) : (
              <DgaButton
                  tabIndex="0"
                disabled={disablePrimaryAction}
                trailIcon={showPrimaryIcon}
                trailIconProps={{ size: 16, type: "standard", variant: "stroke" }}
                trailIconType={resolvedTrailIconType}
                label={primaryActionLabel}
                size="md"
                variant={buttonColor}
                onClick={() => {
                  if (overridePrimaryAction) return overridePrimaryAction();

                  if (external) {
                    window.open(linkPrimaryAction, "_blank", "noopener,noreferrer");
                  } else {
                    window.location.href = linkPrimaryAction;
                  }
                }}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Card;
